import React from 'react';

function StepSectionHeader({title, sectionState, toggleSection}) {
  return (
    <div className={`ct-step__section-header`} onClick={toggleSection}>
      <div>
          {title}
      </div>

        <div className="ct-step__section-header-right">
            {sectionState ? '-' : '+'}
        </div>
    </div>
  );
}

export default StepSectionHeader;
